import { Component, OnInit } from '@angular/core'
import { Router } from '@angular/router'
import { NotificationService } from '@shared/utils/notification.service'
import { AuthService } from '@components/auth/auth.service'

declare var $: any

@Component({
  selector: 'sa-logout',
  template: `
<div id="logout" (click)="showPopup()" class="btn-header transparent pull-right">
        <span> <a routerlink="/auth/login" title="Đăng xuất" data-action="userLogout"
                  data-logout-msg="You can improve your security further after logging out by closing this opened browser"><i
          class="fa fa-sign-out"></i></a> </span>
    </div>
  `,
  styles: [],
})
export class LogoutComponent implements OnInit {
  constructor(
    private router: Router,
    private notificationService: NotificationService,
    private authService: AuthService
  ) { }

  showPopup() {
    this.notificationService.smartMessageBox(
      {
        title:
          "<i class='fa fa-sign-out txt-color-orangeDark'></i> Đăng xuất <span class='txt-color-orangeDark'><strong>" +
          $('#show-shortcut').text() +
          '</strong></span> ?',
        content:
          'Sau khi đăng xuất hãy đóng trình duyệt đang mở này, sẽ giúp bạn cải thiện mức bảo mật.',
        buttons: '[Quay lại][Đăng xuất]',
      },
      ButtonPressed => {
        if (ButtonPressed == 'Đăng xuất') {
          this.logout()
        }
      }
    )
  }

  logout() {
    // this.router.navigate(['/admin/login'])
    this.authService.logout().then(() => this.router.navigate(['/admin/login']))
  }

  ngOnInit() { }
}



// WEBPACK FOOTER //
// ./src/app/shared/user/logout/logout.component.ts